import DOMPurify from 'dompurify';

export const sanitizeHtml: (rawHtml: string) => string = (rawHtml: string) =>
  DOMPurify.sanitize(rawHtml, {
    USE_PROFILES: { html: true },
  });

export const removeHtmlTags: (rawHtml: string) => string = (rawHtml: string) =>
  DOMPurify.sanitize(rawHtml, {
    USE_PROFILES: { html: false },
  });

export const sanitizeHtmlWithoutTargetAttrInAnchor: (
  rawHtml: string
) => string = (rawHtml: string) =>
  DOMPurify.sanitize(rawHtml, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
  });

export const hasTextMeaningfulChars: (text: string) => number = (
  text: string
) => removeHtmlTags(text)?.length;
